import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { FontSize, FontWeight } from '../../../styles/constants';
import { Link } from '../../Link';
import { Heading } from '../../Typography/Heading/Heading';
import { Container as BasedContainer } from '../Layout/Layout.styles';

export const Container = styled.div`
  background-color: ${ThemeColours.mono100};
  padding: 40px 0;
`;

export const Inner = styled(BasedContainer)``;

export const Title = styled(Heading)`
  color: ${ThemeColours.black};
  display: block;
  font-size: ${FontSize.HEADING_5_SMALL};
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-bottom: 8px;
`;

export const LinkContainer = styled.div``;

export const StyledLink = styled(Link)`
  border-right: 1px solid ${ThemeColours.mono600};
  color: ${ThemeColours.mono600};
  display: inline-block;
  font-size: ${FontSize.SMALL};
  margin-bottom: 4px;
  margin-inline-end: 8px;
  padding-inline-end: 8px;
  text-decoration: none;

  &:first-child {
    padding-inline-start: 0;
  }
  &:last-child {
    border-right: none;
    margin-inline-end: 0;
    padding-inline-end: 0;
  }
`;
